const ColumnDefine = class {
  /**
   * 字段名
   */
  columnName = '';

  /**
   * 中文显示名称
   */
  remark = '';

  /**
   * 是否可编辑
   */
  isEdit = false;

  /**
   * 是否可显示
   */
  isList = false;

  /**
   * 编辑类型，如:select/switch/text等
   */
  editType = '';

  /**
   * 下拉列表的来源字典编码
   */
  dataSource = '';

  /**
   * 实体类型，如:string/int
   */
  entityType = '';

  /**
   * 对应的数据字段类型
   */
  columnType = '';

  /**
   * 实体名称
   */
  entityName = '';

  /**
   * 列宽度，例如 '120px' 或 'auto'
   */
  width = 'auto';

  /**
   * 创建一个初始的实体
   */
  static create() {
    return Object.create(this.prototype);
  }

  /**
   * 构造函数
   * @param columnName 字段名
   * @param remark 中文显示名称
   * @param isEdit 是否可编辑
   * @param isList 是否可显示
   * @param editType 编辑类型，如:select/switch/text等
   * @param dataSource 下拉列表的来源字典编码
   * @param entityType 实体类型，如:string/int
   * @param columnType 对应的数据字段类型
   * @param entityName 实体名称
   * @param width 列宽度，例如 '120px' 或 'auto'
   */
  constructor(columnName, remark, isEdit, isList, editType, dataSource, entityType, columnType, entityName, width = 'auto') {
    this.columnName = columnName;
    this.remark = remark;
    this.isEdit = isEdit;
    this.isList = isList;
    this.editType = editType;
    this.dataSource = dataSource;
    this.entityType = entityType;
    this.columnType = columnType;
    this.entityName = entityName;
    this.width = width;
  }
}

export default ColumnDefine;